import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import { find } from '../utils/dom';

const initializeEtica = () => {
  const swiperContainer = document.querySelector(".mySwiperEtica");
  if (!swiperContainer) return;


	const $config = {
		numeracao: find(".swiper-numeracao-etica-ativo"),
		setNumeracao: (_n) =>{
			$config.numeracao.innerText = (_n < 10)? "0"+_n : _n;
		},
		numeracaoTotal: find(".swiper-numeracao-etica .swiper-numeracao-etica-total"),
		setNumeracaoTotal: () =>{
			let n = document.querySelectorAll(".swiper-pagination-etica .swiper-pagination-bullet").length;
			$config.numeracaoTotal.innerText = (n < 10) ? "0"+n : n;
		},
	}

	const SwiperEtica = new Swiper(swiperContainer, {
		slidesPerView: "auto",
    slidesPerGroup: 1,
    spaceBetween: 16,
    navigation: {
      nextEl: ".swiper-button-next-etica",
      prevEl: ".swiper-button-prev-etica",
    },
		pagination:{
			el: ".swiper-pagination-etica",
			clickable: true,
		},
    breakpoints: {
      1280: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      640: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
    },
    on: {
			init: () =>{
				$config.setNumeracaoTotal()
			},
      slideChange: (e) => {
				const barraAtiva = find(".swiper-pagination-etica .swiper-pagination-bullet.swiper-pagination-bullet-active");
				const progress = parseInt(barraAtiva.getAttribute('aria-label').split("Go to slide ")[1]);
				$config.setNumeracao(progress);
      },
			resize: ()=>{
				$config.setNumeracaoTotal()
			}
    }
	})




/*
  const totalSlides = swiperContainer.querySelectorAll(".swiper-slide").length;
  let slidesPerGroup = 4;
  const totalGrupos = Math.ceil(totalSlides / slidesPerGroup);
  let maxBarras = 4;
  const paginationContainer = document.querySelector(".swiper-pagination-etica");
  const numeracaoContainer = document.querySelector(".swiper-numeracao-etica");
  const btnNext = document.querySelector(".swiper-button-next-etica");
  const btnPrev = document.querySelector(".swiper-button-prev-etica");

  if (!paginationContainer || !numeracaoContainer || !btnNext || !btnPrev) return;

  let grupoAtual = 0;
  let paginaAtual = 0;
  const isSingle = true;

  // Inicializa o swiper
  const swiper = new Swiper(swiperContainer, {
    slidesPerView: 1.2,
    slidesPerGroup: 1,
    spaceBetween: 16,
    navigation: {
      nextEl: ".swiper-button-next-etica",
      prevEl: ".swiper-button-prev-etica",
    },
     breakpoints: {
      1280: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      640: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
    },
    on: {
      slideChange: (swiper) => {
        // Atualiza grupo atual e pagina atual baseado no slide ativo
        grupoAtual = Math.floor(swiper.activeIndex / slidesPerGroup);

        const novaPagina = Math.floor(grupoAtual / maxBarras);
        if (novaPagina !== paginaAtual) {
          paginaAtual = novaPagina;
          gerarBarras();    // Recria as barras com nova paginação
        } else {
          atualizarBarras(); // Só atualiza a barra ativa
        }
        atualizarNumeracao(); // Atualiza a numeração
      }
    }
  });

  function gerarBarras() {
    paginationContainer.innerHTML = "";

    const inicio = paginaAtual * maxBarras;
    const fim = Math.min(inicio + maxBarras, totalGrupos);

    for (let i = inicio; i < fim; i++) {
      const barra = document.createElement("div");
      barra.className = "etica-barra-paginacao cursor-pointer w-[37px] h-[2px] rounded-[8px]";
      barra.dataset.index = i;

      barra.addEventListener("click", () => {
        grupoAtual = i;
        swiper.slideTo(i * slidesPerGroup);
        // Atualiza barra e numeração imediatamente ao clicar
        atualizarBarras();
        atualizarNumeracao();
      });

      paginationContainer.appendChild(barra);
    }
    atualizarBarras();
  }

  function atualizarBarras() {
    const barras = paginationContainer.querySelectorAll(".etica-barra-paginacao");
    barras.forEach((barra, i) => {
      const indexGlobal = paginaAtual * maxBarras + i;
      const isAtiva = indexGlobal === grupoAtual;

      if (isAtiva) {
        barra.style.background = "linear-gradient(290deg, #129900 -34.15%, #AEFF00 89.87%)";
      } else {
        barra.style.background = "rgba(255, 255, 255, 0.20)";
      }
    });
  }

  function atualizarNumeracao() {
    numeracaoContainer.innerHTML = `
      <span class="${isSingle ? 'text-white' : 'text-black'}">
        ${String(grupoAtual + 1).padStart(2, '0')}
      </span>
      <span class="${isSingle ? 'text-white/40' : 'text-neutral-10/40'}"> / </span>
      <span class="${isSingle ? 'text-white/40' : 'text-neutral-10/40'}">
        ${String(totalGrupos).padStart(2, '0')}
      </span>
    `;
  }

  // Adiciona controle nos botões next e prev para atualizar estados e UI
  btnNext.addEventListener("click", () => {
    if (grupoAtual < totalGrupos - 1) {
      grupoAtual++;
      swiper.slideTo(grupoAtual * slidesPerGroup);
      atualizarBarras();
      atualizarNumeracao();
    }
  });

  btnPrev.addEventListener("click", () => {
    if (grupoAtual > 0) {
      grupoAtual--;
      swiper.slideTo(grupoAtual * slidesPerGroup);
      atualizarBarras();
      atualizarNumeracao();
    }
  });

  // Estilo para botões desativados (opcional)
  const estilo = document.createElement("style");
  estilo.textContent = `
    .swiper-button-disabled {
      opacity: 1 !important;
      pointer-events: auto !important;
      cursor: pointer !important;
    }
  `;
  document.head.appendChild(estilo);

  // Inicializa as barras e a numeração na primeira carga
  gerarBarras();
  atualizarNumeracao();*/
};

export default initializeEtica;
